export const FOOTBALL = 'FOOTBALL';
